<template>
  <el-form label-width="120px" :inline="true" :model="form" class="demo-form-inline">
    <el-form-item label="用户名ID" required>
      <el-input v-model="form.id" disabled clearable />
    </el-form-item>
    <el-form-item label="昵称" required>
      <el-input v-model="form.nickname" clearable />
    </el-form-item>
    <el-form-item label="用户类型" required>
      <el-select v-model="form.user_type" placeholder="" clearable>
        <el-option label="普通用户" value="normal" />
        <el-option label="专家" value="expert" />
      </el-select>
    </el-form-item>

    <el-form-item label="状态" required>
      <el-select v-model="form.status" placeholder="" clearable>
        <el-option label="正常" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
    </el-form-item>

    <el-form-item label="是否验证" required>
      <el-select v-model="form.is_verified" placeholder="" clearable>
        <el-option label="已验证" :value="true" />
        <el-option label="未验证" :value="false" />
      </el-select>
    </el-form-item>

    <el-form-item label="专家状态" required>
      <el-select v-model="form.expert_status" placeholder="" clearable>
        <el-option label="已批准" value="approved" />
        <el-option label="待审核" value="pending" />
        <el-option label="拒绝" value="rejected" />
      </el-select>
    </el-form-item>
    <el-form-item label="密码" required>
      <el-input v-model="form.password" clearable />
    </el-form-item>
    <el-form-item label="手机号" required>
      <el-input v-model="form.phone" clearable />
    </el-form-item>
    <el-form-item label="邮箱" required>
      <el-input v-model="form.email" clearable />
    </el-form-item>
    <el-form-item label="用户头像" prop="avatar">
      <el-upload class="upload-demo" style="width: 114px" :show-file-list="false" drag :headers="headers"
        :action="`${proxy.BASE_API_URL}user/uploadAvatar`" :data="{ id: form.id }" name="avatar"
        :on-success="successUpload" :on-error="handleErr" :multiple="false">
        <img v-if="form.avatar" :src="form.avatar" width="100%" class="avatar" />
        <el-icon v-else class="avatar-uploader-icon">
          <Plus />
        </el-icon></el-upload>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { getCurrentInstance, nextTick, onMounted, ref } from "vue";
import {
  limitEnums,
  accoutActiveEnums,
  accountTypeEnums,
  userlistSfzStatusEnums,
} from "@/config/enums";
import { getTokenAUTH } from "@/utils/auth";

const form = ref({
  uid: "",
  nickname: "",
  password: "",
  phone: "",
  email: "",
  avatar: "",
  level: "",
  user_type: "",
  status: "",
  is_verified: "",
  expert_status: "",
  expert_title: "",
  expert_intro: ""
});
const props = defineProps(["item"]);

const headers = ref({})
onMounted(() => {
  headers.value['Accept-Token'] = getTokenAUTH()
  nextTick(() => {
    form.value = Object.assign(form.value, props.item);
    getUserState();
  });
});

const successUpload = (res) => {
  if (res.code === 200) {
    form.value.avatar = res.data.avatar_url;
  }
};

const handleErr = (err) => {
  if (err.status == 320) {
    form.value.avatar = JSON.parse(err.message).data.avatar_url;
  }
}

const { proxy } = getCurrentInstance();
const getUserState = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "User/getUserInfo?id=" + form.value.id,
  });

  if (res.code == 0) {
    form.value = Object.assign(form.value, res.data);
  }
};



defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}

.demo-form-inline .el-input {
  --el-input-width: 260px;
}

.demo-form-inline .el-select {
  --el-select-width: 260px;
}

/deep/ .el-radio-group {
  width: 220px;
}

.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}

/deep/ .el-form-item {
  align-items: flex-start;
}
</style>
